export const SCHOLARSHIP_TYPE = {
  GENERAL: 'General',
  ELITE: 'Elite',
  ELITE_PLUS: 'Elite Plus',
  GATE_RANKER: 'GATE Ranker',
  ESE_QUALIFIED: 'ESE Qualified',
  ACE_ALUMNI: 'ACE Alumni',
  ESE_IGP: 'ESE IGP',
};

export const VERIFY_STUDENT_SCHOLARSHIP_STATUS = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
  INCOMPLETE: 'INCOMPLETE',
};

export const VERIFY_DOCUMENT_STATUS = {
  PENDING: 'PENDING',
  VERIFIED: 'VERIFIED',
  REJECTED: 'REJECTED',
  REUPLOAD: 'RE_UPLOAD',
};

export const VerifyStudentScholarship = {
  MERIT_STUDENTS: 'MERIT STUDENTS',
  OLD_STUDENTS: 'OLD STUDENTS',
  SOCIAL_CATEGORY: 'SOCIAL CATEGORY',
  ESE_MAINS_QUALIFIED: 'ESE MAINS QUALIFIED',
};

export const USAGE_LIMIT = {
  UNLIMITED: 'UNLIMITED',
  LIMITED: '',
};
export const SCHOLARSHIP_APPLICABLE = {
  BATCH: 'BATCH',
  SUBSCRIPTION: 'SUBSCRIPTION',
  CATALOGUE: 'CATALOGUE',
};

export const SCHOLARSHIP_APPLICABLE_KEYNAME = {
  [SCHOLARSHIP_APPLICABLE.BATCH]: 'batches',
  [SCHOLARSHIP_APPLICABLE.SUBSCRIPTION]: 'subscriptions',
  [SCHOLARSHIP_APPLICABLE.CATALOGUE]: 'catalogues',
};

export const SCHOLARSHIP_APPLICABLE_IDS = {
  [SCHOLARSHIP_APPLICABLE.BATCH]: 'batchId',
  [SCHOLARSHIP_APPLICABLE.SUBSCRIPTION]: 'subscriptionId',
  [SCHOLARSHIP_APPLICABLE.CATALOGUE]: 'catalogueId',
};

export const SCHOLARSHIP_STATUS = {
  ACTIVE: 'ACTIVE',
  DEACTIVE: 'DEACTIVE',
};

export const MAX_STUDENT_FETCH_SIZE = 100000;
export const SEARCH_MIN_LENGTH = 3;
export const SEARCH_DEBOUNCE_MS = 300;

// Todo: Needs to be deleted
export const ViewScholarshipProgramType = {
  REGULAR: 'Regular Program',
  LIVE: 'Live Program',
  SELF_PACED: 'Self Paced',
  LONG_TERM: 'Long Term Program',
};

// Default scholarship Object used during create scholarship (Hence no id or usageCount)
export const defaultScholarshipModelObject = {
  scholarshipName: '',
  concessionPercentage: 0,
  itemTypes: [], // Batches / subscriptions / catalogs
  program: '',
  course: '',
  validity: null,
  usage: USAGE_LIMIT.UNLIMITED,
  active: true,
  description: '',
};

export class ScholarshipModel {
  constructor(data = defaultScholarshipModelObject) {
    this.id = data.id;
    this.scholarshipName = data.scholarshipName;
    this.concessionPercentage = data.concessionPercentage;
    this.itemTypes = data.itemTypes; // Batches / subscriptions / catalogs
    this.program = data.program;
    this.course = data.course;
    this.validity = data.validity;
    this.usage = data.usage;
    this.active = data.active;
    this.usageCount = data.usageCount;
    this.description = data.description;
  }
}
